import PropTypes from "prop-types";
import React, { Component } from "react";
import { ListItem } from "material-ui/List";
import ChevronIcon from "material-ui/svg-icons/navigation/chevron-left";
import Globalize from "globalize";
import Bottom from "./bottom";
import Spacer from "./spacer";
import { toDataTest } from "helpers/test";
import TextField from "components/form/text-field";

type NumberFilterProps = {
    filter: any;
    activeFiltersValues: any;
    onChange: (value: any) => void;
    field: string;
    hintText: string;
    onFocus?: (e: any) => void;
    onDismiss?: (e: any) => void;
};

class NumberFilter extends Component<NumberFilterProps> {
    static propTypes = {
        filter: PropTypes.object.isRequired,
        activeFiltersValues: PropTypes.object.isRequired,
        onChange: PropTypes.func.isRequired,
        field: PropTypes.string.isRequired,
        hintText: PropTypes.string.isRequired,
        onFocus: PropTypes.func,
        onDismiss: PropTypes.func,
    };

    state: {
        fieldKey: string;
    };

    constructor(props: NumberFilterProps) {
        super(props);
        this.state = {
            fieldKey: props.filter[props.field],
        };

        this.handleChange = this.handleChange.bind(this);
    }

    styles = {
        textField: {
            width: "195px",
            display: "block",
            margin: "0 18px 0 16px",
        },
    };

    handleChange = (event) => {
        const { activeFiltersValues, onChange } = this.props;
        const { fieldKey } = this.state;

        if (!event) {
            onChange(activeFiltersValues.delete(fieldKey));
            return;
        }

        const value = event.target.value;
        const numberValue = value ? parseInt(value, 10) : undefined;

        if (!isNaN(numberValue) || value === "") {
            onChange(
                numberValue !== undefined
                    ? activeFiltersValues.set(fieldKey, numberValue)
                    : activeFiltersValues.delete(fieldKey)
            );
        }
    };

    render() {
        const { activeFiltersValues, hintText, field } = this.props;
        const { fieldKey } = this.state;

        const value = activeFiltersValues.get(fieldKey) || "";
        return (
            <TextField
                name={`numberFilter-${field}`}
                data-test={field + "-" + toDataTest(field)}
                placeholder={hintText}
                value={value}
                fullWidth={false}
                onChange={this.handleChange}
                style={this.styles.textField}
                dialogContainerStyle={{
                    zIndex: 3000,
                }}
                large={false}
                canClear={true}
            />
        );
    }
}

type Props = {
    filter: any;
    activeFiltersValues: any;
    onChange: (values: any) => void;
    onFocus?: (e: any) => void;
    onDismiss?: (e: any) => void;
    lastFilter: boolean;
};

class NumberFilters extends Component<Props> {
    state: {
        open: boolean;
    };

    static contextTypes = {
        muiTheme: PropTypes.object,
    };

    static propTypes = {
        filter: PropTypes.object.isRequired,
        activeFiltersValues: PropTypes.object.isRequired,
        onChange: PropTypes.func.isRequired,
        lastFilter: PropTypes.bool,
    };

    static defaultProps = {
        lastFilter: false,
    };

    styles = {
        nestedListItem: {
            backgroundColor: "transparent",
        },
        listItem: {
            fontSize: "14px",
            fontFamily: "Lato, sans-serif",
        },
        shortListItemInner: {
            padding: "10px 0px 10px 8px",
        },
        dropdownIcon: {
            top: -6,
        },
        dropdownIconOpen: {
            msTransform: "rotate(-90deg)",
            WebkitTransform: "rotate(-90deg)",
            transform: "rotate(-90deg)",
        },
    };

    constructor(props: Props) {
        super(props);
        this.state = {
            open: false,
        };

        this.handleToggleOpen = this.handleToggleOpen.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { filter, activeFiltersValues } = this.props;
        if (activeFiltersValues.get(filter.__min_key) || activeFiltersValues.get(filter.__max_key)) {
            this.setState({
                open: true,
            });
        }
    }

    handleChange(values) {
        const { onChange } = this.props;
        onChange(values);
    }

    handleToggleOpen() {
        this.setState({ open: !this.state.open });
    }

    render() {
        const { filter, activeFiltersValues, lastFilter, onFocus, onDismiss } = this.props;
        const { open } = this.state;
        const styles = this.styles;
        const items = [
            <NumberFilter
                key="min"
                field="__min_key"
                activeFiltersValues={activeFiltersValues}
                filter={filter}
                onChange={this.handleChange}
                onFocus={onFocus ? onFocus : undefined}
                onDismiss={onDismiss ? onDismiss : undefined}
                hintText={Globalize.formatMessage("Min")}
            />,
            <Spacer key="spacer" />,
            <NumberFilter
                key="max"
                field="__max_key"
                activeFiltersValues={activeFiltersValues}
                filter={filter}
                onChange={this.handleChange}
                onFocus={onFocus ? onFocus : undefined}
                onDismiss={onDismiss ? onDismiss : undefined}
                hintText={Globalize.formatMessage("Max")}
            />,
        ];

        if (!lastFilter) {
            items.push(<Bottom key="bottom" />);
        }

        return (
            <ListItem
                primaryText={filter.__name}
                initiallyOpen={open}
                style={styles.listItem}
                nestedItems={items}
                primaryTogglesNestedList={true}
                innerDivStyle={styles.shortListItemInner}
                nestedListStyle={styles.nestedListItem}
                onNestedListToggle={this.handleToggleOpen}
                rightIcon={
                    <ChevronIcon
                        style={Object.assign({}, styles.dropdownIcon, open && styles.dropdownIconOpen)}
                        data-test={`chevron-${toDataTest(filter.__key)}`}
                    />
                }
            />
        );
    }
}

export const FilterInput = NumberFilter;

export default NumberFilters;
